<section class="eco-tl" aria-label="Linha do tempo">
  <div class="eco-tl__head">
    <h2 class="eco-tl__title">Linha do tempo</h2>
    <div class="eco-tl__filters">
      @if (showCompany() && companies().length > 1) {
        <div class="eco-tl__companies" role="group" aria-label="Empresa">
          <app-button
            label="Todas"
            size="small"
            theme="white"
            [noMargin]="true"
            [selected]="companyFilter() === ''"
            (sendClick)="companyFilter.set('')" />
          @for (company of companies(); track company.id) {
            <app-button
              [label]="company.name || 'Empresa'"
              size="small"
              theme="white"
              [noMargin]="true"
              [selected]="companyFilter() === company.id"
              (sendClick)="companyFilter.set(company.id)" />
          }
        </div>
      }
      <app-switch
        label="Só eventos"
        [checked]="onlyEvents()"
        (sendChecked)="onlyEvents.set($event)"></app-switch>
      @if (nodes().length) {
        <div class="eco-tl__expand" role="group" aria-label="Expandir ou recolher">
          <app-button
            label="Expandir tudo"
            icon="angle-double-down"
            size="small"
            theme="white"
            [noMargin]="true"
            (sendClick)="expandAll()" />
          <app-button
            label="Recolher tudo"
            icon="angle-double-up"
            size="small"
            theme="white"
            [noMargin]="true"
            (sendClick)="collapseAll()" />
        </div>
      }
    </div>
  </div>

  @if (nodes().length) {
    <div class="eco-tl__wrapper">
      <p-treeTable
        [value]="nodes()"
        styleClass="eco-tl__tree"
        (onNodeExpand)="onNodeToggle($event, true)"
        (onNodeCollapse)="onNodeToggle($event, false)">
        <ng-template pTemplate="header">
          <tr>
            <th scope="col" class="eco-tl__col-when">Quando</th>
            <th scope="col" class="eco-tl__col-detail">Detalhe / por</th>
            <th scope="col" class="eco-tl__col-bench">Benchmark</th>
            <th scope="col" class="eco-tl__right eco-tl__col-economy">Economia</th>
            <th scope="col" class="eco-tl__right">
              Variação<span class="eco-tl__inline-economy-head"> / economia</span>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
          <tr [ttRow]="rowNode" [ngClass]="'eco-tl__row eco-tl__row--' + rowData.kind">
            <td class="eco-tl__col-when">
              <div class="eco-tl__when-cell">
                <!-- Na folha o toggler fica invisível, mas é ele que dá o recuo do nível. -->
                <p-treeTableToggler [rowNode]="rowNode" />
                <span class="eco-tl__when-text">
                  @switch (rowData.kind) {
                    @case ('day') {
                      <span class="eco-tl__label eco-tl__label--day">{{ rowData.label }}</span>
                      <span class="eco-tl__count">{{ countLabel(rowData) }}</span>
                    }
                    @case ('company') {
                      <span class="eco-tl__label eco-tl__label--company">
                        <i class="pi pi-building" aria-hidden="true"></i>
                        {{ rowData.label }}
                      </span>
                      <span class="eco-tl__count">{{ countLabel(rowData) }}</span>
                    }
                    @case ('reprocessGroup') {
                      <span class="eco-tl__trigger is-event" data-trigger="ManualReprocess">
                        {{ rowData.label }}
                      </span>
                      <span class="eco-tl__muted-text">sem variação</span>
                    }
                    @default {
                      <span class="eco-tl__when">{{ time(rowData.entry) }}</span>
                      <span class="eco-tl__entry-main">
                        <span
                          class="eco-tl__trigger"
                          [class.is-event]="!isAutomatic(rowData.entry.trigger)"
                          [attr.data-trigger]="rowData.entry.trigger">
                          {{ triggerLabel(rowData.entry.trigger) }}
                        </span>
                        <!-- No celular as colunas Detalhe e Benchmark somem: o detalhe vem aqui. -->
                        @if (detail(rowData.entry); as text) {
                          <span class="eco-tl__inline-detail">{{ text }}</span>
                        }
                      </span>
                    }
                  }
                </span>
              </div>
            </td>
            <td class="eco-tl__col-detail eco-tl__detail">
              @if (rowData.kind === 'entry') {
                @if (detail(rowData.entry); as text) {
                  <span [pTooltip]="text" tooltipPosition="top" [showDelay]="400">{{ text }}</span>
                } @else {
                  <span class="eco-tl__muted">–</span>
                }
              } @else if (rowData.kind === 'reprocessGroup' && rowData.authors) {
                por {{ rowData.authors }}
              }
            </td>
            <td class="eco-tl__col-bench eco-tl__bench">
              @if (rowData.kind === 'entry') {
                {{ rowData.entry.benchmarkLabel }}
              }
            </td>
            <td class="eco-tl__right eco-tl__value eco-tl__col-economy">
              @if (rowData.economy !== null) {
                R$&nbsp;{{ rowData.economy | vaultFormatCurrency: 2 }}
              }
            </td>
            <td class="eco-tl__right eco-tl__value" [ngClass]="signClass(rowData.variation)">
              @if (rowData.variation !== null) {
                R$&nbsp;{{ rowData.variation | vaultFormatCurrency: 2 }}
              } @else if (rowData.isFirstVersion) {
                <span class="eco-tl__day-first">primeira versão</span>
              } @else {
                –
              }
              <!-- No celular a coluna Economia some: o valor vem aqui, embaixo da variação. -->
              @if (rowData.economy !== null) {
                <span class="eco-tl__inline-economy">
                  R$&nbsp;{{ rowData.economy | vaultFormatCurrency: 2 }}
                </span>
              }
            </td>
          </tr>
        </ng-template>
      </p-treeTable>
    </div>
  } @else {
    <p class="eco-tl__empty">Nenhuma versão gravada no período com esses filtros.</p>
  }
</section>
